/**
 * @generated SignedSource<<608f4af1a5cabdbfcda4b6156bf47821>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef";
};
export type lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef$key = {
  readonly " $data"?: lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "91dade2591d1180af31cf3ea5a906996";

export default node;
